import React from "react";
var __jsx = React.createElement;
import stl from "./HeroArea.module.css";
var HeroArea = function HeroArea(_ref) {
  var image = _ref.image,
    _ref$title = _ref.title1,
    title1 = _ref$title === void 0 ? "" : _ref$title,
    _ref$title2 = _ref.title2,
    title2 = _ref$title2 === void 0 ? "" : _ref$title2,
    _ref$subTitle = _ref.subTitle,
    subTitle = _ref$subTitle === void 0 ? "" : _ref$subTitle,
    _ref$backGroundColor = _ref.backGroundColor,
    backGroundColor = _ref$backGroundColor === void 0 ? "#266FD1" : _ref$backGroundColor,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? "" : _ref$url,
    _ref$newTab = _ref.newTab,
    newTab = _ref$newTab === void 0 ? false : _ref$newTab;
  var target = newTab ? "_blank" : "_self";
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.CHA_container].join(" "),
    style: {
      backgroundColor: backGroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.CHA_text
  }, /*#__PURE__*/React.createElement("h1", {
    className: stl.title
  }, title1), /*#__PURE__*/React.createElement("p", {
    className: stl.title
  }, title2), /*#__PURE__*/React.createElement("p", null, subTitle), buttonText && /*#__PURE__*/React.createElement("a", {
    target: target,
    className: ["redBtn", stl.buttonColor, "m-hide"].join(" "),
    href: url
  }, " ", buttonText)), /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title1,
    loading: "eager",
    width: "510px",
    height: "280px"
  })));
};
export default HeroArea;